export default function countryCodeToFlagEmoji(countryCode: string): string | null {
  // Ensure the country code is in uppercase
  const code = countryCode.toUpperCase()

  // Check that the input is a valid 2-letter country code
  if (code.length !== 2 || !/^[A-Z]{2}$/.test(code)) {
    return null
  }

  // Convert the country code to the corresponding flag emoji
  const emoji = String.fromCodePoint(...[...code].map(char => char.charCodeAt(0) + 0x1f1a5))

  return emoji
}
